import React, { useMemo } from 'react';

type AccreditationProviderProps = {
  children: React.ReactNode;
};

export type AccreditationProviderResponse = {};

export const AccreditationContext = React.createContext<AccreditationProviderResponse>(
  {} as AccreditationProviderResponse
);

const AccreditationProvider: ({ children }: AccreditationProviderProps) => any = ({ children }) => {
  const contextValue: AccreditationProviderResponse = useMemo(() => ({}), []);

  return <AccreditationContext.Provider value={contextValue}>{children}</AccreditationContext.Provider>;
};

export default AccreditationProvider;
